const SEO = [
	{
		page: "home",
		description:
			"BS in Computer Engineering from the University of Rizal System – Morong Major in Website Development and Database Management. With background knowledge in Web App Development, Database Design, and Implementation of Applications.  ",
		keywords: ["Von", "Von M", "Von Aralar"],
	},

	{
		page: "about",
		description:
			"BS in Computer Engineering from the University of Rizal System – Morong Major in Website Development and Database Management. With background knowledge in Web App Development, Database Design, and Implementation of Applications.  ",
		keywords: ["Von", "Von M", "Von Aralar"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Von", "Von M", "Von Aralar"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Von", "Von M", "Von Aralar"],
	},
];

export default SEO;
